import Map from 'ol/Map';
import { olx } from 'openlayers';
import { BehaviorSubject } from 'rxjs';
import { CustomOlControl } from './custom-ol-control';

export class ZoomControl extends CustomOlControl {
  isToggled$: BehaviorSubject<boolean>;
  duration: number;

  constructor(
    protected map: Map,
    private delta: number = 1,
    className: string,
    options: olx.control.ControlOptions = {}
  ) {
    super((e: any) => this.click(e), className, options);

    this.duration = 250;
  }

  click(e: any) {
    this.zoomByDelta(this.delta);
  }

  zoomByDelta(delta: number): void {
    const view = this.map.getView();
    if (!view) {
      // the map does not have a view, so we can't act
      // upon it
      return;
    }
    const currentResolution = view.getResolution();
    const currentZoom = view.getZoom();
    if (currentResolution && currentZoom) {
      const newZoom = (view as any).getConstrainedZoom(currentZoom + delta);
      const newResolution = view.getResolutionForZoom(newZoom);
      if (this.duration > 0) {
        if (view.getAnimating()) {
          view.cancelAnimations();
        }
        view.animate({
          resolution: newResolution,
          duration: this.duration,
        });
      } else {
        view.setResolution(newResolution);
      }
    }
  }
}
